export const EDITABLE_EVENT_COLOR = '#2e7d32';
export const READONLY_EVENT_COLOR = '#3788d8';
export const CITIZEN_LESS_EVENT_COLOR = '#E1BEE7';
export const NEXUS_EVENT_COLOR = '#5b6c8a';

export const LIGHT_TEXT_COLOR = '#ffffff';
export const DARK_TEXT_COLOR = '#1f1f1f';

export function createRandomCalendarEventId(): string {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }

  return `calendar-event-${Math.random().toString(36).slice(2, 12)}`;
}

export function parseEventDate(value?: Date | string): Date | undefined {
  if (!value) {
    return undefined;
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? undefined : parsed;
}
